import { createSlice } from "@reduxjs/toolkit";
import { getSubCategoryById, getSubCatgeoryList } from "./ThunkActions";
import { iSubCategoryState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iSubCategoryState = {
  isLoading: false,
  subCategory: null,
  errorMessage: null,
  subCategoryList: [],

};
export const subCategoriesSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetSubCategoryState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubCategoryById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSubCategoryById.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.subCategory = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getSubCategoryById.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch order data";
        state.isLoading = false;
      })
      .addCase(getSubCatgeoryList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSubCatgeoryList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.subCategoryList = payload.data;
          state.isLoading = false;
        }
      })
      .addCase(getSubCatgeoryList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch order data";
        state.isLoading = false;
      })
    
  },
});

export const { resetSubCategoryState } = subCategoriesSlice.actions;
export default subCategoriesSlice.reducer;
